import React, { useState, useEffect } from 'react';

// // Main App component to render the Ebook component
// function App() {
//   return (
//     // min-h-screen: Ensures component takes at least full viewport height
//     // bg-gradient-to-br: Creates a subtle diagonal background gradient for a fresh feel
//     // from-blue-50 to-indigo-100: Defines the start and end colors of the gradient
//     // flex items-center justify-center: Centers the content vertically and horizontally
//     // p-4 sm:p-6: Adds responsive padding
//     // font-inter: Sets the default font to Inter for a modern look
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4 sm:p-6 font-inter">
//       <Ebook />
//     </div>
//   );
// }

// Ebook Component (now manages multiple books)
function Ebook() {
  const [isPdfViewerActive, setIsPdfViewerActive] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState('');
  const [isLoadingPdf, setIsLoadingPdf] = useState(true); // New state for PDF loading indicator

  // Sample book data. For 100+ books, you'd typically fetch this from an API.
  // Using diverse placeholder covers and dummy PDF links for demonstration.
  const books = [
    {
      id: 'book-1',
      title: 'Introduction to AI',
      description: 'Explore foundational concepts of Artificial Intelligence and its impact on the modern world. This book provides a clear and concise overview for beginners.',
      cover: 'https://placehold.co/300x400/98c1d9/293241?text=AI+Basics',
      pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
    },
    {
      id: 'book-2',
      title: 'Advanced Robotics',
      description: 'Dive deep into the mechanics and programming of advanced robotic systems. Learn about kinematics, dynamics, and control algorithms.',
      cover: 'https://placehold.co/300x400/8d86c9/f4f4f8?text=Robotics+Expert',
      pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
      id: 'book-3',
      title: 'Machine Learning Basics',
      description: 'A comprehensive guide to machine learning algorithms and practical applications, covering supervised and unsupervised learning techniques.',
      cover: 'https://placehold.co/300x400/ee6c4d/f4f4f8?text=ML+Guide',
      pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
    },
    {
      id: 'book-4',
      title: 'Data Science Fundamentals',
      description: 'Understand the core principles and tools for data analysis and visualization. Master Python and R for statistical modeling.',
      cover: 'https://placehold.co/300x400/3d5a80/e0f2f7?text=Data+Insights',
      pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
      id: 'book-5',
      title: 'Neural Networks Decoded',
      description: 'Unravel the complexities of neural networks, from perceptrons to deep learning architectures. Explore convolutional and recurrent networks.',
      cover: 'https://placehold.co/300x400/a8dadc/1d3557?text=NN+Explained',
      pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
    },
    {
      id: 'book-6',
      title: 'Ethical AI',
      description: 'Explore the critical ethical considerations in the development and deployment of artificial intelligence. Discuss bias, fairness, and accountability.',
      cover: 'https://placehold.co/300x400/fca311/14213d?text=AI+Ethics',
      pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
      id: 'book-7',
      title: 'Web Development Mastery',
      description: 'Master the full stack of web development, from frontend frameworks like React to backend technologies and databases.',
      cover: 'https://placehold.co/300x400/457b9d/f1faee?text=Web+Mastery',
      pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
    },
    {
      id: 'book-8',
      title: 'Cybersecurity Essentials',
      description: 'Learn the fundamentals of cybersecurity, including network security, cryptography, and best practices for protecting digital assets.',
      cover: 'https://placehold.co/300x400/2a9d8f/264653?text=Cyber+Secure',
      pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
      id: 'book-9',
      title: 'Quantum Computing',
      description: 'An introduction to the revolutionary field of quantum computing, exploring quantum algorithms and their potential applications.',
      cover: 'https://placehold.co/300x400/c77dff/f0f0f0?text=Quantum+Leap',
      pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
    },
  ];

  // Function to handle clicking on a "Read Ebook" button
  const handleReadEbookClick = (pdfUrl) => {
    setCurrentPdfUrl(pdfUrl); // Set the PDF URL for the viewer
    setIsLoadingPdf(true); // Start loading state
    setIsPdfViewerActive(true); // Activate the viewer overlay
    document.body.style.overflow = 'hidden'; // Prevent scrolling on the main page
  };

  // Function to close the PDF viewer overlay
  const handleClosePdfViewer = () => {
    setIsPdfViewerActive(false); // Deactivate the viewer overlay
    setCurrentPdfUrl(''); // Clear the PDF URL to stop loading in the iframe
    setIsLoadingPdf(true); // Reset loading state
    document.body.style.overflow = ''; // Re-enable scrolling on the main page
  };

  // Effect to close the PDF viewer when the Escape key is pressed
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isPdfViewerActive) {
        handleClosePdfViewer();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPdfViewerActive]); // Re-run effect if isPdfViewerActive changes

  return (
    // Main container for the ebook library
    // bg-white: White background for the card
    // rounded-3xl: More rounded corners for a softer look
    // shadow-2xl: Deeper shadow for more depth
    // p-8 lg:p-12: Increased responsive padding
    // max-w-7xl: Increased max-width to accommodate more columns
    // overflow-hidden: Ensures no content spills out, especially with shadows
    <div className="ebook-container bg-white rounded-3xl shadow-2xl p-8 lg:p-12 max-w-7xl w-full text-center relative overflow-hidden">
      {/* Main title for the ebook library */}
      {/* text-4xl sm:text-5xl: Larger responsive font size */}
      {/* font-extrabold: Extra bold font weight */}
      {/* text-gray-900: Darker text for better contrast */}
      {/* mb-12: More margin at the bottom */}
      {/* relative pb-4: For the underline effect */}
      <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-12 relative pb-4">
        Discover Our Modern Ebook Library
        {/* Decorative underline */}
        {/* absolute bottom-0 left-1/2 -translate-x-1/2: Centers the underline */}
        {/* w-24 h-1.5: Slightly wider and thicker underline */}
        {/* bg-teal-500: A vibrant teal color for the underline */}
        {/* rounded-full: Rounded ends for the underline */}
        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1.5 bg-teal-500 rounded-full"></span>
      </h2>

      {/* Grid container for all book cards */}
      {/* grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4: More granular responsive columns */}
      {/* gap-8: Consistent spacing between cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {/* Map through the books array to render a BookCard for each book */}
        {books.map((book) => (
          <BookCard key={book.id} book={book} onReadClick={handleReadEbookClick} />
        ))}
      </div>

      {/* PDF Viewer Overlay - Conditionally rendered when a book is being read */}
      {isPdfViewerActive && (
        // fixed inset-0: Full screen overlay
        // bg-black bg-opacity-90: Dark, semi-transparent background
        // z-50: High z-index to ensure it's on top
        // transition-opacity duration-300: Smooth fade-in/out
        <div
          className="pdf-viewer-overlay fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 transition-opacity duration-300"
          onClick={handleClosePdfViewer} // Close when clicking the semi-transparent background
          role="dialog"
          aria-modal="true"
          aria-labelledby="pdfViewerTitle"
        >
          {/* Content container for the PDF viewer */}
          {/* w-[95vw] h-[95vh] sm:w-[90vw] sm:h-[90vh]: Responsive width and height */}
          {/* bg-gradient-to-br from-blue-50 to-indigo-100: New gradient background for the viewer content */}
          {/* rounded-xl shadow-2xl overflow-hidden: Rounded corners, deep shadow */}
          {/* p-4 sm:p-6: Added padding inside the content for visual breathing room */}
          <div
            className="pdf-viewer-content relative w-[95vw] h-[95vh] sm:w-[90vw] sm:h-[90vh] bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl shadow-2xl overflow-hidden p-4 sm:p-6 flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()} // Prevent clicks inside content from closing the overlay
          >
            <h2 id="pdfViewerTitle" className="sr-only">Ebook Viewer</h2> {/* Hidden title for accessibility */}
            {/* Close button for the PDF viewer */}
            {/* absolute top-4 right-4: Positions the button in the top right corner */}
            {/* bg-red-600 text-white: Red background, white text */}
            {/* text-4xl: Larger 'x' icon */}
            {/* rounded-full w-12 h-12: Circular button */}
            {/* hover:bg-red-700: Darker red on hover */}
            {/* shadow-lg: More pronounced shadow */}
            <button
              onClick={handleClosePdfViewer}
              className="close-pdf-viewer absolute top-4 right-4 bg-red-600 text-white text-4xl rounded-full w-12 h-12 flex items-center justify-center cursor-pointer z-50 hover:bg-red-700 transition-colors duration-300 shadow-lg"
              aria-label="Close Ebook Viewer"
            >
              &times; {/* HTML entity for a multiplication sign (looks like 'x') */}
            </button>

            {/* Conditional rendering for loading indicator or iframe */}
            {isLoadingPdf && (
              <div className="flex flex-col items-center justify-center text-gray-700 text-xl font-semibold animate-pulse">
                <svg className="animate-spin h-10 w-10 text-teal-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading Ebook...
              </div>
            )}

            {currentPdfUrl && (
              <iframe
                id="ebookPdfFrame"
                src={currentPdfUrl}
                title="Ebook PDF Viewer"
                className="w-full h-full border-none rounded-md bg-white shadow-inner" // Full width and height, no border, rounded, inner shadow, white background for content
                aria-label="PDF document viewer"
                onLoad={() => setIsLoadingPdf(false)} // Set loading to false once iframe content is loaded
                style={{ display: isLoadingPdf ? 'none' : 'block' }} // Hide iframe until loaded
              ></iframe>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// BookCard Component - A dedicated component for displaying a single book's details
function BookCard({ book, onReadClick }) {
  return (
    // book-card: Custom class for additional styling if needed (not directly used by Tailwind)
    // bg-white: White background for the card
    // rounded-2xl: More rounded corners
    // shadow-lg: Deeper initial shadow
    // transition-all duration-300: Smooth transitions for all properties
    // hover:shadow-xl hover:-translate-y-2: More dynamic hover effect (deeper shadow, slight lift)
    // flex flex-col items-center: Centers content within the card vertically
    // p-6: Increased padding inside the card
    // overflow-hidden: Ensures content doesn't spill out, especially with the cover image
    <div className="book-card bg-white rounded-2xl shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-2 flex flex-col items-center p-6 overflow-hidden">
      {/* Book Cover Image */}
      {/* book-cover: Custom class (not directly used by Tailwind) */}
      {/* w-48 h-64 sm:w-52 sm:h-72: Responsive width and height for the cover */}
      {/* bg-cover bg-center: Ensures image covers the area and is centered */}
      {/* rounded-lg: Rounded corners for the cover image */}
      {/* shadow-md: Shadow specifically for the cover image */}
      {/* mb-5: More margin below the cover */}
      {/* flex-shrink-0: Prevents cover from shrinking on smaller screens */}
      {/* transform transition-transform duration-300 hover:scale-105: Subtle zoom on hover for the cover */}
      <div
        className="book-cover w-48 h-64 sm:w-52 sm:h-72 bg-cover bg-center rounded-lg shadow-md mb-5 flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
        style={{ backgroundImage: `url('${book.cover}')` }}
        aria-label={`Cover for ${book.title}`}
      ></div>
      {/* Book Details: Title, Description, Read Button */}
      <div className="book-details text-left flex-grow w-full">
        {/* text-xl sm:text-2xl: Responsive font size for title */}
        {/* font-bold: Bold font weight */}
        {/* text-gray-900: Darker title text */}
        {/* mb-2: Margin below title */}
        {/* truncate: Ensures title doesn't wrap excessively */}
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 truncate">
          {book.title}
        </h3>
        {/* text-gray-700: Slightly darker description text */}
        {/* text-base leading-relaxed: Standard text size with relaxed line height */}
        {/* mb-5: More margin below description */}
        {/* line-clamp-3: Limits description to 3 lines for consistent card height */}
        <p className="text-gray-700 text-base leading-relaxed mb-5 line-clamp-3">
          {book.description}
        </p>
        {/* Read Ebook button */}
        {/* w-full: Button takes full width of the card */}
        {/* bg-gradient-to-r from-green-500 to-teal-500: Gradient background for a modern look */}
        {/* text-white font-semibold: White text, semi-bold font */}
        {/* py-3 px-6: Increased padding for a larger touch target */}
        {/* rounded-full: Pill-shaped button */}
        {/* shadow-lg: Deeper shadow for the button */}
        {/* hover:from-green-600 hover:to-teal-600: Darker gradient on hover */}
        {/* focus:outline-none focus:ring-4 focus:ring-green-300 focus:ring-offset-2: Focus state for accessibility */}
        {/* transform hover:scale-105: Subtle zoom effect on hover */}
        <button
          onClick={() => onReadClick(book.pdfUrl)} // Pass the book's PDF URL to the handler
          className="read-ebook-btn w-full bg-gradient-to-r from-green-500 to-teal-500 text-white font-semibold py-3 px-6 rounded-full text-lg shadow-lg hover:from-green-600 hover:to-teal-600 focus:outline-none focus:ring-4 focus:ring-green-300 focus:ring-offset-2 transition-all duration-300 ease-in-out transform hover:scale-105"
          aria-label={`Read ${book.title}`}
        >
          Read Ebook
        </button>
      </div>
    </div>
  );
}



export default Ebook; // Export App as the default component for the environment
